import React, { useState } from "react";
import styled from "styled-components";
import * as yup from "yup";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import axios from "lib/api";
import GenericError from "components/GenericError";
import { ButtonRow, ConfirmModalContent } from "styles/elements/main";
import { FormGroup, FormRow } from "styles/forms/main";
import { Button, Input, ModalComponent } from "components";
import Spinner from "components/Spinner";
import SectionsData from "modules/shared/profiles/SectionsData";

const Wrapper = styled.div`
    padding: 35px;
`;
const HeaderWrapper = styled.div`
    display: flex;
    align-items: baseline;
`;
const Header = styled.h2`
    font-size: 24px;
    font-weight: bold;
    margin-right: 40px;
`;
const DetailsTitle = styled.h3`
    color: #006bb4;
    font-size: 18px;
    font-weight: 600;
    margin-block: 30px;
`;
const DetailsWrapper = styled.div`
    display: flex;
    align-items: baseline;
`;
function UpdateAccount({ phoneNumber, id, setCreateAccountDone }) {
    const [openModal, setOpenModal] = useState(false);
    const [discardUpdate, setDiscardUpdate] = useState(false);
    const [accountData, setAccountData] = useState();
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [backendErrors, setBackErrors] = useState();
    const validationSchema = yup.object().shape({
        password: yup.string().min(6).required(),
        re_enter_password: yup.string().when("password", {
            is: (password) => password && password.length > 0,
            then: () => yup.string().oneOf([yup.ref("password"), null], "Passwords must match"),
            otherwise: () => yup.string(),
        }),
    });
    const handleDataFroSubmit = (e) => {
        const { name, value } = e?.target;
        setAccountData({
            ...accountData,
            [name]: value,
        });
    };

    const handleOpenModal = () => {
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setDiscardUpdate(false);
        setOpenModal(false);
    };
    const handleDiscardUpdate = () => {
        setDiscardUpdate(!discardUpdate);
    };
    const submitData = (e) => {
        e.preventDefault();
        validationSchema
            .validate(accountData, { abortEarly: false })
            .then(async () => {
                setIsLoading(true);
                axios
                    .put(`/drivers/${id}`, {
                        data: {
                            type: "drivers",
                            id,
                            attributes: {
                                password: accountData?.password,
                                passwordConfirmation: accountData?.re_enter_password,
                            },
                        },
                    })
                    .then(() => {
                        setIsLoading(false);
                        handleCloseModal();
                        setCreateAccountDone(true);
                    })
                    .catch((err) => {
                        setIsLoading(false);
                        setBackErrors(err?.errors);
                    });
            })
            .catch((err) => {
                const errorslist = err?.inner?.reduce(
                    (acc, error) => ({
                        ...acc,
                        [error?.path]: error?.message,
                    }),
                    {}
                );

                setErrors(errorslist);
            });
    };
    return (
        <>
            <Wrapper>
                <HeaderWrapper>
                    <Header>Mobile app management</Header>
                    <Button
                        name="Update account"
                        btnStyle="primaryBtn"
                        onChange={handleOpenModal}
                    />
                </HeaderWrapper>
                <DetailsTitle>Authentication Info</DetailsTitle>
                <DetailsWrapper>
                    <SectionsData
                        label="Mobile Number"
                        text={phoneNumber}
                    />
                    <SectionsData
                        label="Password"
                        text="********"
                    />
                </DetailsWrapper>
            </Wrapper>
            <ModalComponent
                header="Create New driver app Account"
                borderedHeader
                size="large"
                open={openModal}
                onClose={handleDiscardUpdate}
            >
                <FormRow>
                    <FormGroup>
                        <Input
                            label="Mobile Number"
                            value={phoneNumber}
                            disableWithBorder
                        />
                    </FormGroup>
                </FormRow>
                <FormRow>
                    <FormGroup>
                        <Input
                            label="Password"
                            name="password"
                            error={errors?.password}
                            errorMessage={errors?.password}
                            isEditable
                            type="password"
                            placeholder="******"
                            onChange={(e) => handleDataFroSubmit(e)}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Input
                            label="Re-enter Password"
                            name="re_enter_password"
                            error={errors?.re_enter_password}
                            errorMessage={errors?.re_enter_password}
                            isEditable
                            type="password"
                            placeholder="******"
                            onChange={(e) => handleDataFroSubmit(e)}
                        />
                    </FormGroup>
                </FormRow>
                <ButtonRow>
                    <Button
                        onChange={handleDiscardUpdate}
                        name="Cancel"
                        btnStyle="secondBtn"
                        type="button"
                    />
                    <Button
                        btnStyle={isLoading ? "disabled" : "primaryBtn"}
                        type="submit"
                        name={isLoading ? <Spinner /> : "Update"}
                        disabled={isLoading}
                        icon={!isLoading && <AddCircleOutlineOutlinedIcon />}
                        onChange={submitData}
                    />
                </ButtonRow>
                {backendErrors && <GenericError errorMassege={backendErrors} />}
            </ModalComponent>
            {discardUpdate && (
                <ModalComponent
                    header="Leave “Update driver app Account” Page"
                    borderedHeader
                    isFooter
                    cancelBtn
                    submitBtn
                    open={discardUpdate}
                    submitBtnText="Leave"
                    onSubmit={handleCloseModal}
                    onClose={handleDiscardUpdate}
                >
                    <ConfirmModalContent>
                        You have unsaved changes that will be lost if you leave the page.
                    </ConfirmModalContent>
                </ModalComponent>
            )}
        </>
    );
}

export default UpdateAccount;
